/* Carrito: "Pagar pedido" abre el mismo cuadro de forma de pago que "Comprar ahora" (1 tarjeta / 2 contra entrega).
   Funciona en el carrito lateral y en la pagina del carrito. El boton propio de la app de contra entrega queda oculto por CSS y se acciona desde aqui. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dlg = document.querySelector('[data-cart-pay]');
  if (!dlg) return;
  var codBtn = function () { return document.getElementById('rsi_buy_now_button'); };

  function open() {
    var codItem = dlg.querySelector('[data-cart-pay-cod-item]');
    if (codItem) codItem.hidden = !codBtn();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var sum = dlg.querySelector('[data-cart-pay-sum]');
      if (sum) sum.textContent = c.item_count + (c.item_count === 1 ? ' producto' : ' productos');
    }).catch(function () { /* sin resumen */ });
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    requestAnimationFrame(function () { dlg.classList.add('is-open'); });
    var first = dlg.querySelector('[data-cart-pay-card]'); if (first) first.focus({ preventScroll: true });
  }
  function close() {
    dlg.classList.remove('is-open');
    setTimeout(function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }, reduce.matches ? 0 : 350);
  }

  /* Intercepta el boton de pagar del carrito (lateral y pagina) antes de que envie el formulario */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="checkout"], #CartDrawer-Checkout');
    if (!b || b.disabled || b.closest('[data-cart-pay]')) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  dlg.querySelector('[data-cart-pay-close]').addEventListener('click', close);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dlg.querySelector('[data-cart-pay-card]').addEventListener('click', function () { window.location.href = '/checkout'; });
  dlg.querySelector('[data-cart-pay-cod]').addEventListener('click', function () {
    close();
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.close) { try { drawer.close(); } catch (err) { /* noop */ } }
      var b = codBtn(); if (!b) return;
      /* El formulario de la app vive dentro del panel del carrito, que esta desplazado fuera de pantalla cuando esta cerrado:
         mientras el formulario este abierto se deja el panel quieto (CSS .v-cod-open) para que se vea. */
      var host = document.querySelector('cart-drawer');
      if (host) {
        host.classList.add('v-cod-open');
        var seen = false, tries = 0;
        var timer = setInterval(function () {
          var f = document.querySelector('dialog.rsi-form-wrapper-dialog');
          if (f && f.open) seen = true;
          if ((seen && !(f && f.open)) || ++tries > 600) { clearInterval(timer); host.classList.remove('v-cod-open'); }
        }, 500);
      }
      b.click();
    }, reduce.matches ? 0 : 380);
  });
})();
